import React from 'react';

const PhoneSearchPanel = React.forwardRef(function PhoneSearchPanel(
  { phone, onPhoneChange, onSubmit, loading },
  ref,
) {
  return (
    <form onSubmit={onSubmit} className="rounded-[30px] border border-[rgba(148,163,184,0.22)] bg-white px-6 py-6 shadow-[0_24px_60px_rgba(15,23,42,0.06)]">
      <div className="space-y-4">
        <div className="space-y-1.5">
          <p className="text-[11px] uppercase tracking-[0.32em] text-slate-400">Entrada rápida</p>
          <label className="block text-sm font-medium text-slate-600">Buscar por número móvil</label>
        </div>

        <div className="grid gap-4 lg:grid-cols-[1fr_220px]">
          <input
            ref={ref}
            type="tel"
            value={phone}
            onChange={(event) => onPhoneChange(event.target.value)}
            placeholder="Ej: 600123123"
            className="w-full rounded-[24px] border border-[rgba(148,163,184,0.30)] bg-[rgba(248,250,252,0.96)] px-6 py-5 text-[28px] font-semibold tracking-[-0.03em] text-slate-900 shadow-[inset_0_1px_0_rgba(255,255,255,0.85),0_1px_2px_rgba(15,23,42,0.04)] placeholder:text-slate-300 focus:border-[rgba(0,113,227,0.28)] focus:outline-none focus:ring-4 focus:ring-[rgba(0,113,227,0.10)]"
          />
          <button
            type="submit"
            disabled={loading}
            className="rounded-[24px] bg-[#0a84ff] hover:bg-[#0077ed] text-white text-xl font-semibold py-4 shadow-[0_18px_30px_rgba(10,132,255,0.22)] transition disabled:opacity-60"
          >
            {loading ? 'Buscando...' : 'Buscar'}
          </button>
        </div>
      </div>
    </form>
  );
});

export default PhoneSearchPanel;
